<template>
  <private-template>
    <template v-slot:private-template>
      <div class="viewContainer">
        <TitleView title="Proveedores"/>
        <div class="viewContainer__content">
          <SupplierBlock />
        </div>
      </div>
    </template>
  </private-template>
</template>

<script>
import TitleView from '@/components/atoms/TitleView/TitleView.vue';
import PrivateTemplate from '@/templates/PrivateTemplate.vue';
import SupplierBlock from '@/components/molecules/Supplier/SupplierBlock.vue';

export default {
  name: 'Supplier',
  components: {
    PrivateTemplate,
    TitleView,
    SupplierBlock,
  },
};
</script>
